export const getPageName = (key) => key && key.replace(/-/g, ' ')
